export default function Django_Variables() {
  return <div>Django_Variables Component</div>;
}
